<div class="modal confirm-modal fade show d-block {{type}}" *ngIf="showAlert" 
  id="success-modal" tabindex="-1" aria-labelledby="confirmation-modal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <button type="button" *ngIf="!hideCancelButton" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="confirm(false)"></button>
            <div class="modal-body">
                <div class="confirm-modal-body">
                    <div class="image-icon"></div>
                    <h2>{{title}}</h2>
                    <p>{{text}}</p>
                    <div class="confirm-buttons">
                        <button  *ngIf="!hideCancelButton" class="btn btn-outline-secondary" (click)="confirm(false)" (keyup.enter)="confirm(false)">{{cancelText}}</button>
                        <button *ngIf="!hideOkButton" class="btn btn-primary"  (click)="confirm(true)" (keyup.enter)="confirm(true)">{{okText}}</button>
                    </div>
                </div>

            </div>
        </div>

    </div>
</div>